import dict from '@/config/dict.js';

/**
 * 取字典列表（用于下拉/单选等渲染）
 * dictList('violateType') => [{label, value}, ...]
 */
export function dictList(key) {
	const list = dict[key];
	return Array.isArray(list) ? list : [];
}

/**
 * 字典翻译函数
 *  - 只传 key：返回整个字典数组，便于 v-for（兼容旧用法）
 *  - 传 key + value：返回对应 label，找不到则返回 defaultValue
 *
 * dictTrans('income', 1) => '5w以下'
 * dictTrans('violateType') => [{label, value}, ...]
 */
export function dictTrans(key, value, defaultValue = '') {
	const list = dictList(key);
	if (arguments.length < 2) {
		return list;
	}
	if (list.length === 0) {
		return defaultValue;
	}
	// 兼容字符串/数字
	const item = list.find((i) => i.value === value || String(i.value) === String(value));
	return item ? item.label : defaultValue;
}

